import React, { useEffect, useState } from 'react';
import EchartWordCloud from '../Echarts/WordCloudChart';
import NoData from '../NoData';
import { IWordCloud } from '../ReportTrend';

const WordCloudChart = (props: { data: IWordCloud[] }) => {
  const { data } = props;
  const [isNoData, setIsNoData] = useState(false);

  useEffect(() => {
    if (!data || data.length === 0) {
      setIsNoData(true);
    } else {
      setIsNoData(false);
    }
  }, [data]);

  const option = getOption(data);
  return (
    <section>
      <div className='title'>
        <h3>Word cloud</h3>
      </div>
      <div className='chart-container' style={{ height: '280px' }}>
        {isNoData ? <NoData/> : <EchartWordCloud chartOption={option} />}
      </div>
    </section>
  );
};

export default WordCloudChart;

const getOption = (data: IWordCloud[] = []) => {
  return {
    data: data.map((d: IWordCloud) => {
      return {
        name: d.name,
        value: parseInt(d.count, 10),
      };
    }),
  };
};
